import { Box, TableCell, TableRow } from '@mui/material'
import AddTimepointSubmissionChip from './AddTimepointSubmissionChip.tsx'
import { TimepointSubmissionRow } from '@features/subject/subject.types.ts'
import TimepointSubmissionChip from './TimepointSubmissionChip.tsx'
import { useUiStore } from '@features/qc_task_details_view/store/uiStore.ts'
import { useParams } from 'react-router-dom'

export default function TimepointSubmissionTableRow({
  timepointSubmissionRow,
  subjectPseudoId,
  subjectId,
  assignableTimepointSubmissions,
  handleSelectTimepointSubmission,
}: {
  timepointSubmissionRow: TimepointSubmissionRow
  subjectPseudoId: string
  subjectId: string
  assignableTimepointSubmissions: string[]
  handleSelectTimepointSubmission: (timepointSubmissionId: string, subjectId: string) => void
}) {
  const { setTempSelectedTimepointSubmission } = useUiStore()
  const { timepointSubmissionId } = useParams()

  return (
    <TableRow
      data-testid="timepoint-submission-row"
      sx={{
        zIndex: 1,
        position: 'relative',
      }}
    >
      <TableCell
        padding="checkbox"
        sx={{
          width: '20%',
          minWidth: 48,
          bgcolor: 'background.default',
          position: 'sticky',
          left: 0,
          zIndex: 30,
          boxSizing: 'border-box',
          tableLayout: 'fixed',
        }}
        data-testid="empty-cell-0"
      />
      <TableCell
        sx={{
          width: 170,
          minWidth: 170,
          bgcolor: 'background.default',
          position: 'sticky',
          left: 48,
          zIndex: 30,
          boxSizing: 'border-box',
          tableLayout: 'fixed',
        }}
        data-testid="empty-cell-1"
      />
      <TableCell
        sx={{
          width: 120,
          minWidth: 120,
          bgcolor: 'background.default',
          position: 'sticky',
          left: 168,
          zIndex: 30,
          boxSizing: 'border-box',
          tableLayout: 'fixed',
        }}
        data-testid="empty-cell-2"
      />
      <TableCell
        sx={{
          width: 120,
          minWidth: 120,
          bgcolor: 'background.default',
          position: 'sticky',
          left: 288,
          zIndex: 30,
          boxSizing: 'border-box',
          tableLayout: 'fixed',
        }}
        data-testid="empty-cell-3"
      />
      <TableCell
        sx={{
          width: 120,
          minWidth: 120,
          bgcolor: 'background.default',
          position: 'sticky',
          left: 408,
          zIndex: 30,
          boxSizing: 'border-box',
          tableLayout: 'fixed',
        }}
        data-testid="empty-cell-4"
      />
      <TableCell
        sx={{
          width: 120,
          minWidth: 120,
          bgcolor: 'background.default',
          position: 'sticky',
          left: 528,
          zIndex: 30,
          boxSizing: 'border-box',
          tableLayout: 'fixed',
        }}
        data-testid="empty-cell-5"
      />
      {timepointSubmissionRow.timepoint_submissions.map((timepointSubmission, index) => (
        <TableCell
          key={index}
          sx={{
            paddingX: 0.5,
            paddingY: 0.25,
            minWidth: 220,
            boxSizing: 'border-box',
            zIndex: 1,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          data-testid={`timepoint-cell-${index}`}
        >
          {timepointSubmission.timepoint_submission
            ? (() => {
                const isDisabled =
                  timepointSubmission.timepoint_submission.timepoint_submission_id === timepointSubmissionId ||
                  !assignableTimepointSubmissions.includes(
                    timepointSubmission.timepoint_submission.timepoint_submission_id,
                  )

                return (
                  <Box
                    sx={{
                      cursor: isDisabled ? 'not-allowed' : 'pointer',
                      zIndex: 1,
                      position: 'relative',
                    }}
                    onClick={
                      isDisabled
                        ? undefined
                        : () => {
                            setTempSelectedTimepointSubmission(
                              timepointSubmission.timepoint_submission!.timepoint_submission_id,
                              timepointSubmission.timepoint_submission!.name,
                              subjectPseudoId,
                            )
                            handleSelectTimepointSubmission(
                              timepointSubmission.timepoint_submission!.timepoint_submission_id,
                              subjectId,
                            )
                          }
                    }
                  >
                    <TimepointSubmissionChip
                      timepoint={timepointSubmission.timepoint_submission}
                      isDisabled={isDisabled}
                      data-testid={`timepoint-chip-${index}`}
                    />
                  </Box>
                )
              })()
            : timepointSubmission.isLast && (
                <AddTimepointSubmissionChip
                  timepointId={timepointSubmission.timepoint_id || ''}
                  data-testid={`add-timepoint-chip-${index}`}
                  subjectId={subjectId}
                />
              )}
        </TableCell>
      ))}
    </TableRow>
  )
}
